
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"26","viewBox":"0 0 22 26","width":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"height":"24","rx":"1.5","stroke":"#343440","width":"19.833","x":"1.083","y":"1"}}),_c('g',{attrs:{"fill":"#343440"}},[_c('path',{attrs:{"d":"M15.39 15.162H6.61c-.078 0-.154-.029-.21-.08s-.087-.12-.087-.191a3.977 3.977 0 01.502-1.941 4.43 4.43 0 011.413-1.527 1.097 1.097 0 011.044-.092 4.104 4.104 0 001.722.376c.598 0 1.188-.13 1.722-.376a1.09 1.09 0 011.05.092 4.413 4.413 0 011.411 1.51 3.96 3.96 0 01.51 1.925c.001.076-.03.148-.084.204a.347.347 0 01-.214.1zM10.991 10.757a3.6 3.6 0 01-1.863-.513c-.552-.335-.981-.81-1.235-1.367s-.32-1.169-.191-1.76c.13-.59.449-1.133.918-1.558s1.066-.716 1.717-.834c.65-.117 1.325-.057 1.938.173s1.136.621 1.505 1.122.565 1.09.565 1.692c0 .4-.087.796-.255 1.165-.169.37-.416.705-.727.988a3.394 3.394 0 01-1.088.66 3.65 3.65 0 01-1.284.232z"}}),_c('rect',{attrs:{"height":"1.042","rx":".521","width":"12.5","x":"4.75","y":"17.167"}}),_c('rect',{attrs:{"height":"1.042","rx":".521","width":"12.5","x":"4.75","y":"20.292"}})])])
          )
        }
      }
    